/** @file Rows of the Shortcuts section: every default binding with its effective chord, by context then id. */
import { applyOverrides } from '@pose2d/shortcuts/applyOverrides';
import type { Binding, Platform } from '@pose2d/shortcuts/types';

/** One binding as the section shows it; `keys` is '' when unbound. */
export interface ShortcutRowData {
  id: string;
  context: string;
  keys: string;
  defaultKeys: string;
  overridden: boolean;
}

/** Effective keys come from applyOverrides, so a stored override the table cannot take shows as the default. */
export function shortcutRows(defaults: readonly Binding[], overrides: readonly Binding[], platform: Platform): ShortcutRowData[] {
  const slot = (b: Binding): string => `${b.context}/${b.id}`;
  const effective = new Map(applyOverrides(defaults, overrides, platform).table.map((b) => [slot(b), b.keys]));
  return defaults
    .map((b) => {
      const keys = effective.get(slot(b)) ?? '';
      return { id: b.id, context: b.context, keys, defaultKeys: b.keys, overridden: keys !== b.keys };
    })
    .sort((a, b) => a.context.localeCompare(b.context, 'en') || a.id.localeCompare(b.id, 'en'));
}
